<div class="row">
  <div class="col-12">
    <div class="row row-cols-2 row-cols-md-4">
      <!-- Total Users -->
      <div class="col mt-4 mt-lg-0">
        <div class="card shadow-sm p-3 d-flex flex-row align-items-center justify-content-center" style="height: 100px;">
          <div class="d-flex flex-column me-4">
            <i class="fas fa-users fa-2x text-primary mb-1"></i>
            <small class="text-muted">Benutzer</small>
          </div>
          <h2 class="mb-0">{{ totalUsers }}</h2>
        </div>
      </div>

      <!-- Visitors -->
      <div class="col mt-4 mt-lg-0">
        <div class="card shadow-sm p-3 d-flex flex-row align-items-center justify-content-center" style="height: 100px;">
          <div class="d-flex flex-column me-4">
            <i class="fas fa-eye fa-2x text-success mb-1"></i>
            <small class="text-muted">Besucher</small>
          </div>
          <h2 class="mb-0">{{ totalVisitors }}</h2>
        </div>
      </div>

      <!-- Articles -->
      <div class="col mt-4 mt-lg-0">
        <div class="card shadow-sm p-3 d-flex flex-row align-items-center justify-content-center" style="height: 100px;">
          <div class="d-flex flex-column me-4">
            <i class="fas fa-newspaper fa-2x text-warning mb-1"></i>
            <small class="text-muted">Artikel</small>
          </div>
          <h2 class="mb-0">{{ totalArticles }}</h2>
        </div>
      </div>

      <!-- Job Applications -->
      <div class="col mt-4 mt-lg-0">
        <div class="card shadow-sm p-3 d-flex flex-row align-items-center justify-content-center" style="height: 100px;">
          <div class="d-flex flex-column me-4">
            <i class="fas fa-briefcase fa-2x text-danger mb-1"></i>
            <small class="text-muted">Bewerbungen</small>
          </div>
          <h2 class="mb-0">{{ totalApplications }}</h2>
        </div>
      </div>
    </div>

    <div class="row g-4 mt-4">
      <div class="col-12 col-md-8">
        <div class="card" style="height: 430px;">
          <div class="card-body">
            <!-- Period selection -->
            <div class="d-flex justify-content-end mb-2">
              <button class="btn btn-outline-primary me-2" (click)="loadMonthlyVisitors('day')" [disabled]="selectedPeriod === 'day'">Tag</button>
              <button class="btn btn-outline-primary" (click)="loadMonthlyVisitors('month')" [disabled]="selectedPeriod === 'month'">Monat</button>
            </div>

            <!-- Chart -->
            <div #monthlyChart></div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="card" style="height: 430px;">
          <div class="card-body">
            <ul class="notification">
              <li><h6 class="dropdown-header">Benachrichtigungen</h6></li>
              <li *ngFor="let notification of notifications" 
                  [class.unread]="notification.status === 'UNREAD'" 
                  class="p-3 m-3 rounded-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="table-noti-icon">
                      <i [class]="sharedService.getNotificationIcon(notification.type)"></i>
                    </div>
                    <div class="table-noti-message ms-3">
                      <h6>
                        <a href="javascript:void(0);">{{ notification.title }}</a>
                      </h6>
                      <span class="message-time">{{ notification.timestamp.toDate() | date:'medium' }}</span>
                    </div>
                  </div>
                  <div class="position-relative">
                    <button class="btn btn-sm btn-light" 
                            (click)="toggleDropdown(notification)">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div *ngIf="notification.isOpen" class="dropdown-menu show">
                      <button class="dropdown-item" (click)="markAsRead(notification)">Als gelesen markieren</button>
                      <button class="dropdown-item text-danger" (click)="deleteNotification(notification)">Löschen</button>
                    </div>
                  </div>
                </div>
              </li>

              <div class="alert alert-info" *ngIf="notifications.length == 0">
                <i class="fa-solid fa-circle-info me-2"></i> Es gibt noch keine Benachrichtigungen
              </div>
              <li><hr class="dropdown-divider" *ngIf="notifications.length"></li>
              <li *ngIf="notifications.length"><a class="dropdown-item text-center text-primary" [routerLink]="['/Admin/Notifications']" (click)="updateAllNotifications(userUid)">Alle anzeigen</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>